import { timelineSteps } from '@/mocks/clearing';
import SectionHeading from './SectionHeading';

const stateStyles: Record<string, string> = {
  '已证实': 'bg-background-200 text-foreground-800',
  '存疑': 'bg-accent-100 text-accent-900',
  '待核': 'bg-background-200 text-foreground-800',
  '反转': 'bg-primary-500 text-background-50 dark:text-foreground-950',
  '已澄清': 'bg-secondary-500 text-background-50 dark:text-foreground-950',
};

const dotStyles: Record<string, string> = {
  neutral: 'bg-background-400',
  warn: 'bg-accent-500',
  flip: 'bg-primary-500',
  ok: 'bg-secondary-500',
};

export default function TimelineSection() {
  return (
    <section id="timeline" className="scroll-mt-24 bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-[1180px] px-4 md:px-6">
        <SectionHeading
          index="03"
          eyebrow="Reverse Timeline"
          title="反转时间线 · 结论是在哪一步被改写的"
          desc="以「图书馆占座冲突」为例，把流传、质疑、回应、取证、通报五个节点按小时铺开。看反转，其实就是看证据在哪一刻补上了。"
        />

        <div className="mt-12 grid grid-cols-1 gap-12 lg:grid-cols-12">
          <div className="lg:col-span-8">
            <ol className="relative border-l border-background-300 pl-6 md:pl-8">
              {timelineSteps.map((step, index) => (
                <li
                  key={step.time}
                  data-reveal
                  style={{ transitionDelay: `${index * 70}ms` }}
                  className={`relative ${index !== timelineSteps.length - 1 ? 'pb-9' : ''}`}
                >
                  <span
                    className={`absolute -left-[31px] top-1.5 h-3 w-3 rounded-full ring-4 ring-background-50 md:-left-[39px] ${
                      dotStyles[step.tone] ?? 'bg-background-400'
                    }`}
                    aria-hidden="true"
                  />
                  <div className="flex flex-wrap items-center gap-3">
                    <span className="font-label text-xs tracking-[0.12em] text-foreground-500">
                      {step.time}
                    </span>
                    <span
                      className={`rounded-full px-2.5 py-1 font-label text-[11px] font-medium ${
                        stateStyles[step.state] ?? 'bg-background-200 text-foreground-800'
                      }`}
                    >
                      {step.state}
                    </span>
                  </div>
                  <h3 className="mt-2.5 font-heading text-base font-semibold text-foreground-950 md:text-lg">
                    {step.title}
                  </h3>
                  <p className="mt-2 max-w-2xl text-[13px] leading-relaxed text-foreground-600 md:text-sm">
                    {step.desc}
                  </p>
                </li>
              ))}
            </ol>
          </div>

          <aside data-reveal className="lg:col-span-4">
            <div className="rounded-lg border border-background-200 bg-background-100/70 p-6">
              <div className="flex h-10 w-10 items-center justify-center rounded-md bg-accent-100 text-accent-800">
                <i className="ri-lightbulb-flash-line text-lg" />
              </div>
              <h3 className="mt-4 font-heading text-base font-semibold text-foreground-950">
                读时间线的三个提醒
              </h3>
              <ul className="mt-4 flex flex-col gap-4">
                <li className="flex gap-3 text-[13px] leading-relaxed text-foreground-600">
                  <span className="font-heading text-sm font-bold text-primary-500">1</span>
                  先确认第一条视频的完整长度，再看它被剪掉了什么。
                </li>
                <li className="flex gap-3 text-[13px] leading-relaxed text-foreground-600">
                  <span className="font-heading text-sm font-bold text-primary-500">2</span>
                  当事人发声的时间顺序，往往比内容本身更说明问题。
                </li>
                <li className="flex gap-3 text-[13px] leading-relaxed text-foreground-600">
                  <span className="font-heading text-sm font-bold text-primary-500">3</span>
                  「反转」不等于「洗白」，也可能只是真相变得更复杂。
                </li>
              </ul>
              <a
                href="#responses"
                className="mt-6 inline-flex items-center gap-2 whitespace-nowrap font-label text-xs text-primary-700 transition-colors duration-200 hover:text-primary-500"
              >
                看当事人原话
                <i className="ri-arrow-right-line" />
              </a>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}